<template>
  <div>
    <div
      class="container">
      <grid-row
        column-align="center">
        <grid-col
          col-size="4">
          <div
            class="logo-wrapper">
            <login-logo-mobile class="logo" />
          </div>
          <br><br>
        </grid-col>
      </grid-row>
      <grid-row
        column-align="center">
        <grid-col
          col-size="4">
          <div
            class="license-agreement"
            v-html="termsAndConditions">
          </div>
          <br>
          <hr>
          <br>
          <div
            class="license-agreement"
            v-html="privacyPolicy">
          </div>
        </grid-col>
      </grid-row>
    </div>
  </div>
</template>

<script>
import LoginLogoMobile from '@/components/shared/logos/LoginLogoMobile';
import MainLayout from '@/layouts/MainLayout';
import GridRow from '@/components/shared/grid/GridRow';
import GridCol from '@/components/shared/grid/GridCol';
import config from 'BRAND/config';

export default {
  components: {
    MainLayout,
    LoginLogoMobile,
    GridRow,
    GridCol
  },
  data () {
    return {
      termsAndConditions: this.$t(config.termAndConditions),
      privacyPolicy: this.$t(config.privacyPolicy)
    };
  }
};
</script>

<style lang="scss" scoped>
  @import "src/stylesheets/variables";

  .logo-wrapper {
    margin-top: $sp-margin;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
  }

  .logo {
    width: 6rem;
    height: auto;
  }

  .title-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
  }

</style>



// WEBPACK FOOTER //
// src/layouts/Legal.vue